import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  RESET_LOGIN_FLAG,
  TWO_FACTOR_REQUIRED,
} from "./actionTypes";

export const loginUser = (data) => {
    console.log("Login user action:", data);
  if (!data.user.email || !data.user.password || (data.user.totpCode && !/^\d{6}$/.test(data.user.totpCode))) {
    throw new Error('Invalid login data: email and password are required, TOTP must be 6 digits if provided');
  }
  return {
    type: LOGIN_USER,
    payload: { user:data.user, navigate:data.navigate },
  };
};

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const logoutUser = (data) => ({
  type: LOGOUT_USER,
  payload: { navigate:data.navigate },
});

export const logoutUserSuccess = () => ({
  type: LOGOUT_USER_SUCCESS,
});

export const apiError = (error, twoFactorRequired = false) => ({
  type: API_ERROR,
  payload: { data: error.message || error, twoFactorRequired },
});

export const resetLoginFlag = () => ({
  type: RESET_LOGIN_FLAG,
});

export const twoFactorRequired = () => ({
  type: TWO_FACTOR_REQUIRED,
});